/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

/**
 * API[実績一覧取得: /result/gridList]のペイロードを表すインターフェース。
 * @export
 * @interface
 *
 * @property {integer} pageNo ページ番号(任意)
 * @property {integer} pageSize 1ページあたりの表示件数(任意)
 */
export interface ResultGridListPayload {
    pageNo?: number;
    pageSize?: number;
}

/**
 * API[実績一覧取得: /result/gridList]の正常応答を表すインターフェース。
 * @export
 * @interface
 * @property resultGridList 実績タブ_集合研修一覧リスト
 */
export interface ResultGridListResponse {
    /** 実績タブ_集合研修一覧リスト */
    resultGridList: ResultGridListItem[];
}

export interface ResultGridListItem {
    compulsoryId: string;
    compulsoryName: string;
    careerTitle: string;
    classTitle: string;
    jissiKikan: string;
    status: string;
    imstatListStatusId: number;
    jukou: string;
    jissiStartDateODT: string;
    jissiEndDateODT: string;
    careerId: string;
    careerTypeId: string;
    classId: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    resultStatus: number;
    seq: string;
    multiApplyFlag: string;
    testFlg: boolean;
    careerImageUrl: string;
    classroom: string;
    startDate: string;
    endDate: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    retakeOkFlg: string;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
    aplType: string;
}

/**
 * API[実績一覧取得: /result/gridList]用のサービスクラス。
 */
class ResultGridListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "result/gridList");
    }

    public async fetch(payload?: ResultGridListPayload): Promise<ResultGridListResponse> {
        return super.postWithPromise(payload).then((json: unknown) => {
            const response = json as ResultGridListResponse;
            return response;
        });
    }

    /**
     * 結果が1ページに収まらない場合に繰り返し取得して全件取得する
     * @param payload 
     * @returns 
     */
    public async fetchAll(payload?: { pageSize?: number }): Promise<ResultGridListResponse> {
        const pageSize = payload?.pageSize ?? 9999;
        const responseStack: ResultGridListResponse["resultGridList"][] = [];
        for (let pageNo = 1; ; ++pageNo) {
            try {
                const result: unknown = await this.fetch({ pageNo, pageSize });

                if (!result ||
                    typeof result !== 'object' ||
                    !('resultGridList' in result) ||
                    !Array.isArray(result.resultGridList) ||
                    result.resultGridList.every(x => typeof x !== 'object')
                ) {
                    console.error("failed to fetch result/gridList - result:", result);
                    break;
                }

                // 要素ごとのバリデーションは省略
                const resultGridList = result.resultGridList as ResultGridListItem[];

                // 0件の時はpushせずにbreakしたほうが早いがコードが微妙に複雑になるので省略
                responseStack.push(resultGridList);

                if (resultGridList.length < pageSize) {
                    break; // 確実に次のページがない
                }
            } catch (e) {
                console.error("failed to fetch result/gridList", e);
                break;
            }
        }
        return { resultGridList: responseStack.flatMap(x => x) };
    }
}

export default ResultGridListService;
